import { defineMessages } from "react-intl";
import { useDispatch } from "react-redux";
import classNames from "classnames";

import Button from "../Buttons/Button";
import { useFormatMessage } from "../Intl/Context";
import { updateMineOnly } from "../../reducers/resourcesList/search";
import { useResourcesList } from "../ResourcesList/resourcesList";

const MineFilter = props => {
  const dispatch = useDispatch();
  const t = useFormatMessage();
  const mineLabel = t(intlMessages.mine);
  const mineFilterSrLabel = t(intlMessages.mineFilterSrLabel);

  const { resourcesListKey, search } = useResourcesList();
  const { mineOnly } = search;

  const className = classNames(["filter", "mine-filter", props.className]);
  const iconClassName = classNames([
    "icon-pencil",
    "margin-right-xs",
    "text-shadow-primary",
    {
      "text-white": !mineOnly,
      "text-primary": mineOnly
    }
  ]);

  const handleButtonClicked = () => dispatch(updateMineOnly(resourcesListKey, !mineOnly));

  return (
    <div className={className}>
      <Button
        aria-label={mineFilterSrLabel}
        type="button"
        className="btn-unstyled btn-block one-line"
        onClick={handleButtonClicked}
        label={mineLabel}
        iconClassName={iconClassName}
        innerClassName="d-inline-flex align-items-center"
      />
    </div>
  );
};

export default MineFilter;

const intlMessages = defineMessages({
  mine: {
    id: "contributions.list.filters.mine",
    defaultMessage: "Mes contributions"
  },
  mineFilterSrLabel: {
    id: "contributions.list.filters.mineFilterSrLabel",
    defaultMessage: "Filtrer par mes contributions"
  }
});
